//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SketchGeometricConstraint.js";
import "../no/Expression.js";
let d=[[[0,"AssociatedDimension",0,"Annotations.Dimension",0],[1,"AssociatedExpression",0,"Expression",0]],[[["dist"],"UpdateDistance",{},1,0]],[]];
SPLM.SketchOffset = class extends SPLM.SketchGeometricConstraint{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchOffset";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchOffset.CapType = Object.freeze({
    "Extension" : "Extension", "Arc" : "Arc"});

export default SPLM;